export default __webpack_public_path__ + "static/media/personGrey.df0e2bc8.svg";